import React from "react";

const About = () => {
    return (
        <section>
            <div className="about" id="about">
                <h1>ABOUT</h1>
                <p>
                    Aute aliqua ex quis in veniam quis duis occaecat ex fugiat
                    esse culpa incididunt non. Quis ullamco commodo laboris
                    aliqua magna occaecat ut sint ex minim velit ut. Pariatur
                    quis irure dolore adipisicing esse est anim minim nulla enim
                    veniam ex voluptate. Esse ipsum labore magna ea.
                </p>
                <span className="about-divider"></span>
                <span className="about-name">Joe Doe</span>
                <span className="about-position">Founder</span>
                <span className="about-name">Jane Doe</span>
                <span className="about-position">General Manager</span>
                <span className="about-name">Jack Doe</span>
                <span className="about-position">Head Chef</span>
            </div>
        </section>
    );
};

export default About;
